import React, { useState } from 'react';
import { supabase } from '../supabaseclient';

export default function Login() {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErro('');

    const { error } = await supabase.auth.signInWithPassword({
      email,
      password: senha,
    });

    if (error) {
      setErro('Acesso negado. Verifique seu e-mail e senha.');
      setLoading(false);
    }
    // O App.js detectará a mudança de sessão automaticamente
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 p-4">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-2xl overflow-hidden">
        
        {/* CABEÇALHO INSTITUCIONAL */}
        <div className="p-8 text-center bg-gray-50 border-b border-gray-100">
          <div className="flex justify-center items-center mb-4">
            <img 
              src="/brasao-mirassol.png" 
              alt="Brasão de Mirassol" 
              className="h-16 w-auto drop-shadow-sm" 
            />
          </div>
          
          <h1 className="text-2xl font-black text-blue-900 tracking-tight leading-tight uppercase">
            Sistema de Gestão
          </h1>
          <p className="text-gray-500 text-xs font-bold mt-1 tracking-widest uppercase">
            Fundo Social de Mirassol
          </p>
        </div>

        {/* FORMULÁRIO DE ACESSO */}
        <form onSubmit={handleLogin} className="p-8 space-y-5">
          {erro && (
            <div className="bg-red-50 border-l-4 border-red-500 p-3 text-red-700 text-xs font-bold animate-pulse">
              ⚠️ {erro}
            </div>
          )}

          <div>
            <label className="block text-[10px] font-black text-gray-400 uppercase ml-1 mb-1 tracking-widest">
              E-mail Institucional
            </label>
            <input 
              type="email" 
              className="input-field" 
              placeholder="exemplo@mirassol.sp.gov.br"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div>
            <label className="block text-[10px] font-black text-gray-400 uppercase ml-1 mb-1 tracking-widest">
              Senha de Acesso
            </label>
            <input 
              type="password" 
              className="input-field" 
              placeholder="••••••••"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              required
            />
          </div>

          <button 
            disabled={loading}
            className={`w-full py-4 rounded-2xl font-black text-white shadow-lg transition-all active:scale-95 
              ${loading ? 'bg-gray-400' : 'bg-blue-700 hover:bg-blue-800'}`}
          >
            {loading ? "AUTENTICANDO..." : "ENTRAR NO SISTEMA"}
          </button>

          <div className="pt-4 text-center border-t border-gray-50">
            <p className="text-[10px] text-gray-400 italic">
              Este sistema é de uso exclusivo dos servidores autorizados. <br/>
              Acesso monitorado por IP e Credenciais.
            </p>
          </div>
        </form>
      </div>
      
      {/* RODAPÉ DO MUNICÍPIO */}
      <div className="fixed bottom-4 text-white/40 text-[10px] font-bold uppercase tracking-[0.2em]">
        Prefeitura Municipal de Mirassol - São Paulo
      </div>
    </div>
  );
}

        
